
	import Vue from "vue";
	import TaxLookup from "../components/TaxLookup.vue";

	export default Vue.extend({
		name: "Reevaluation",

		props: ["disclaimer", "note"],

		data() {
			return {
				isLoading: true,
			};
		},
		components: {
			TaxLookup,
		},
	});
